import { checkLogin } from "../../utils/jwt";
import css from "../../styles/ProductDisclaimer.module.css";

const ProductDisclaimer = ({ discountDisclaimer }) => {
  const isLoggedIn = checkLogin();
  if (isLoggedIn || !discountDisclaimer) return null;
  return (
    <div className={css.productDisclaimer}>
      <p>{discountDisclaimer}</p>
    </div>
  );
};

export default ProductDisclaimer;
